// Types
import type { I_setDeviceStatus, I_setDeviceStatus_Return } from "./it4SetDeviceStatus.types.js";

// Libs
import axios from "../configRequest.js";
// Data
import { I_AXIOS } from "../configRequest.model.js";

/**
 * Установить статус девайса в ИТ4 на ORDER_CREATED | ONLINE_CONTRACT_GENERATED
 * 18.1 документация
 */
const it4SetDeviceStatus: I_setDeviceStatus = async ({ token, deviceId, status }) => {
    const setDeviceStatus = await axios.post<I_setDeviceStatus_Return["data"]>(
        `${I_AXIOS.STAGE_API_HOST}/api/tin/v1/site/quest/agc-status`,
        {
            deviceId,
            status,
        },
        {
            headers: {
                Accept: "application/json;charset=UTF-8",
                "Content-Type": "application/json",
                "x-auth-token": token,
            },
        },
    );
    return setDeviceStatus.data;
};

export default it4SetDeviceStatus;
